import { useSocketEvents, useTrips } from '@hooks'
import { useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CreateTripModal from './CreateTripModal'
import JoinTripModal from './JoinTripModal'
import TripsList from './TripsList'

const TripsPage: React.FC = () => {
	const navigate = useNavigate()
	const { data: tripsData, isLoading, error } = useTrips()
	const queryClient = useQueryClient()
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
	const [isJoinModalOpen, setIsJoinModalOpen] = useState(false)

	// Socket.IO event handlers - refresh trips list when updates occur
	useSocketEvents({
		onTripUpdated: () => {
			queryClient.invalidateQueries({ queryKey: ['trips'] })
		},
	})

	const handleTripClick = (trip: Trip) => {
		navigate(`/trips/${trip.id}`)
	}

	const handleCreateTrip = () => {
		setIsCreateModalOpen(true)
	}

	const handleJoinTrip = () => {
		setIsJoinModalOpen(true)
	}

	return (
		<>
			<TripsList
				trips={tripsData?.trips || []}
				loading={isLoading}
				error={error ? 'Failed to load trips' : null}
				onTripClick={handleTripClick}
				onCreateTrip={handleCreateTrip}
				onJoinTrip={handleJoinTrip}
			/>
			<CreateTripModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} />
			<JoinTripModal isOpen={isJoinModalOpen} onClose={() => setIsJoinModalOpen(false)} />
		</>
	)
}

export default TripsPage
